app.controller('teacherAppGroupMapCtrl', [
    '$scope', '$interval', '$state', '$stateParams', 'gameService', 'teacherAppService', '$interval', 'locationService', function ($scope, $interval, $state, $stateParams, gameService, teacherAppService, $interval, locationService) {
    	var vm = this;

    	vm.gameService = gameService;

		vm.curPos = [0.0, 0.0];

    	vm.map = new maptalks.Map('maptalksc', {
        	center: vm.gameService.config.mapCenter,
        	zoom: 16.64,
        	bearing: 150.0,
        	attribution: false,

	        //allow map to drag pitching, true by default
        	dragPitch : false,
        	//allow map to drag rotating, true by default
        	dragRotate : true,
        	//enable map to drag pitching and rotating at the same time, false by default
        	dragRotatePitch : false,

        	baseLayer: new maptalks.TileLayer('base', {
          		urlTemplate: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          		subdomains: ['a','b','c','d'],
          		attribution: ''
        	})
      	});

		var center = vm.map.getCenter();
		var layer = new maptalks.VectorLayer('vector').addTo(vm.map);

		vm.rideMarkers = {};
        for (var i = 0; i < vm.gameService.rides.length; i++) {
            var ride = vm.gameService.rides[i];

            if (ride.enabled) {
                var marker = new maptalks.Marker(ride.location, {
                    'symbol' : {
                        'markerFile'   : ride.markerImage,
                        'markerWidth'  : ride.markerWidth,
                        'markerHeight' : ride.markerHeight,
                        'markerDx'     : 0,
                        'markerDy'     : 0,
                        'markerOpacity': 1
                    }
                });
                vm.rideMarkers[ride.key] = marker;
                marker.addTo(layer);
            }
        }

       // Add the You marker.
       vm.youMarker = new maptalks.Marker(vm.curPos, {
          	'symbol' : {
            	'markerFile'   : window.location.origin + '/img/map/MapPinLærer.svg',
                'markerWidth'  : 2*22,
                'markerHeight' : 2*35.5,
            	'markerDx'     : 0,
            	'markerDy'     : 0,
            	'markerOpacity': 1
          	}
        });
        vm.youMarker.addTo(layer);

        vm._intervalPromise = $interval(function() {
        	vm.onLocationUpdated();
            vm.updateMarkerLocations();
        }, 1000);

        $scope.$on('$destroy', function() {
        	$interval.cancel(vm._intervalPromise);
        });

        vm.gameMarkers = [];
        vm.createGameMarkers = function() {
            if (vm.gameMarkers.length === 0) {
                var gameInfos = teacherAppService.gameInfo;
                for (var i = 0; i < gameInfos.length; i++) {
                    if (i > 9) {
                        // XXX: we currently only have images for 1-10.
                        continue;
                    }

                    var gameInfo = gameInfos[i];
                    var marker = new maptalks.Marker(gameInfo.locationState.lastLocation, {
                        'symbol' : {
                            'markerFile'   : window.location.origin + '/img/map/MapPin' + (i + 1) + '.svg',
                            'markerWidth'  : 2*22,
                            'markerHeight' : 2*35.5,
                            'markerDx'     : 0,
                            'markerDy'     : 0,
                            'markerOpacity': 1
                        }
                    });
                    marker.addTo(layer);

                    vm.gameMarkers.push(marker);
                }
            }
        }

        vm.updateMarkerLocations = function() {
            vm.createGameMarkers();

            var gameInfos = teacherAppService.gameInfo;
            for (var i = 0; i < gameInfos.length; i++) {
                var gameInfo = gameInfos[i];
                var teamNumber = i + 1;
                var marker = vm.gameMarkers[i];
                marker.setCoordinates(gameInfo.locationState.lastLocation);

                // Set a random zindex for the marker.
                // First, we generate a random number between 0 and gameInfos.length + 1 (to compensate for the teacher marker).
                // Then we add 1 to the result to reserve 0 for the ride markers.
                marker.setZIndex(Math.floor(Math.random() * (gameInfos.length + 1)) + 1);
            }
        }

        $scope.$on('teacherAppServiceUpdated', function(gameInfo) {
            vm.updateMarkerLocations();
        });

        vm.onLocationUpdated = function () {
        	var pos = locationService.getLocation();
        	if (!pos) {
        		return;
        	}

        	vm.curPos = [pos.lng, pos.lat];
        	vm.youMarker.setCoordinates(vm.curPos);

            // Set a random zindex for the marker.
            // First, we generate a random number between 0 and gameInfos.length + 1 (to compensate for the teacher marker).
            // Then we add 1 to the result to reserve 0 for the ride markers.
            var gameInfos = teacherAppService.gameInfo;
            vm.youMarker.setZIndex(Math.floor(Math.random() * (gameInfos.length + 1)) + 1);
        }

        // Update the teacher marker location.
        vm.onLocationUpdated();

        // Update marker locations on load; the teacherAppService has already
        // been updated at login.
        vm.updateMarkerLocations();

        vm.sendMessage = function() {
            $state.go('teacherapp.messages');
        }
   }
]);